import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
const { Option } = Select;

import { OptionProps } from '@digital/ui';

interface ISelectInfinityProps {
  paginationOptions?: OptionProps[];
  value?: string;
  onChange?: (value: string) => void;
  paginationSize?: number;
  placeholder?: string;
  label?: string;
}

export const SelectInfinity = ({
  paginationOptions,
  value,
  onChange,
  paginationSize = 20,
  placeholder = 'Selecione ou pesquise...',
  label,
}: ISelectInfinityProps) => {
  if (!paginationOptions) return <></>;

  const [page, setPage] = useState(0);
  const [inputValue, setInputValue] = useState(''); 
  const [options, setOptions] = useState<OptionProps[]>([]);

   useEffect(() => {
    if (paginationOptions && paginationOptions.length > 0) {
      const filtered = inputValue
        ? paginationOptions.filter(opt =>
            String(opt.text).toLowerCase().includes(inputValue.toLowerCase())
          )
        : paginationOptions;

      let slice = filtered.slice(0, (page + 1) * paginationSize);

      const current = paginationOptions.find(
        opt => String(opt.value) === String(value)
      );
      if (current && !slice.find(o => String(o.value) === String(current.value))) {
        slice = [current, ...slice];
      }

      setOptions(
        slice.map(opt => ({
          ...opt,
          value: String(opt.value),
        }))
      );
    }
  }, [page, paginationOptions, paginationSize, inputValue, value]);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;
    const nearBottom =
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20;
    if (nearBottom) {
      setPage(prev => prev + 1);
    }
  };

  const handleSearch = (val: string) => {
    setInputValue(val);
    setPage(0);
  };

  return (
    <>
     {label && <label style={{ display: 'block', marginBottom: 4 }}>{label}</label>}
    <Select
    
      showSearch
      value={value}
      style={{ width: '100%' }}
      placeholder={placeholder}
      optionFilterProp="value"
      onSearch={handleSearch}
      filterOption={false} 
      onChange={val => onChange && onChange(val)}
      onPopupScroll={handleScroll}
    >
      {options && options.length > 0 && (
        options.map(opt => (
          <Option key={String(opt.value)} value={String(opt.value)}>
            {opt.text}
          </Option>
        ))
      ) }
    </Select>
  </>
};
